import { Search } from "@mui/icons-material";
import { useEffect, useRef, useState } from "react";
import {
  useRecoilCallback,
  useRecoilState,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import {
  atencionFetchState,
  atencionState,
  clinicasFetchState,
  clinicasState,
  covenantsState,
  examenState,
  professionalsState,
  serviciosState,
  specialitiesState,
  sucursalesState,
  tipoExamenState,
} from "src/SearchHours/components/autocompletes/state/atoms";
import {
  activeTabState,
  filterSearchSelectedState,
  hoursAvailableState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "src/SearchHours/state/atoms";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";
import { encryptJSON } from "src/shared/global/cryptoJSUtilities";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { mobileUserState } from "src/store/global/userMobileState";
import ReactGA from "react-ga4";

export default function ButtonSearch() {
  const [loading, setLoading] = useState(false);
  //const history = useHistory();
  const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);
  const mountedRef = useRef(true);
  const { catchErrorApi } = useCatchErrorApi();

  //const theme = useTheme();

  //const valuesFormReservationGuest = useRecoilValue(valuesFormReservationGuestState);
  //const valuesFormReservationUser = useRecoilValue(valuesFormReservationUserState)
  const setProfessionals = useSetRecoilState(professionalsState);
  const setSpecialities = useSetRecoilState(specialitiesState);
  const setCovenants = useSetRecoilState(covenantsState);

  const setTipoExamen = useSetRecoilState(tipoExamenState);
  const setExamen = useSetRecoilState(examenState);
  const setServicio = useSetRecoilState(serviciosState);
  //const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const resetFilterSearchSelected = useResetRecoilState(
    filterSearchSelectedState
  );

  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );

  //const setPreloader = useSetRecoilState(preloaderState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);

  const [tabsDisabled, setTabsDisabled] = useState({
    one: false,
    two: false,
  });

  const setSucursales = useSetRecoilState(sucursalesState);
  const setClinicas = useSetRecoilState(clinicasState);
  const setAtencion = useSetRecoilState(atencionState);

  // const handleChangeTab = (event, newValue) => {
  //   setActiveTabSearch(newValue);
  // };

  const eventGA = () => {
    console.log("Evento Google Analytics -> Buscar");
    let especialidad = filterSearchSelected.specialitySelected.value;
    especialidad = especialidad != "" ? `| Especialidad: ${especialidad}` : "";
    let profesional = filterSearchSelected.professionalSelected.value;
    profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
    let prevision = filterSearchSelected.covenantSelected.value;
    prevision = prevision != "" ? `| Previsión: ${prevision}` : "";
    let clinica = filterSearchSelected.clinicaSelected.value;
    clinica = clinica != "" ? `Clinica: ${clinica}` : "";
    console.log(`ga ${clinica} ${especialidad} ${profesional} ${prevision}`);
    ReactGA.event({
      category: 'Buscar',
      action: `${clinica} ${especialidad} ${profesional} ${prevision}`
    });
  };

  const eventImagenologiaGA = () => {
    console.log("Evento Google Analytics -> Buscar Imagenologia");
    let tipoExamen = filterSearchSelected.tipoExamenSelected.value;
    tipoExamen = tipoExamen != "" ? `| TipoExamen: ${tipoExamen}` : "";
    let examen = filterSearchSelected.examenSelected.value;
    examen = examen != "" ? `| Examen: ${examen}` : "";
    let clinica = filterSearchSelected.clinicaSelected.value;
    clinica = clinica != "" ? `Clinica: ${clinica}` : "";
    console.log(`ga ${clinica} ${tipoExamen} ${examen} `);
    ReactGA.event({
      category: 'Buscar',
      action: `${clinica} ${tipoExamen} ${examen}`
    });
  };
  const setUserMobile = useSetRecoilState(mobileUserState);

  const loadResultSearchCentral = () => {
    console.log("loadResultSearchCentral...");
    // window.location.reload(false);
    // setUserMobile(false);
    const objEncryptJson = encryptJSON(filterSearchSelected);
    console.log(objEncryptJson);
    // window.open(
    //   `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda?ext=${objEncryptJson}`,
    //   "_blank"
    // );
    window.location.replace(
      `${process.env.REACT_APP_ROOT_SERVER_PATH}?ext=${objEncryptJson}`
    );
  };
  // const loadResultSearchCentral = useRecoilCallback(({ snapshot }) => async () => {
  //   const release = snapshot.retain();
  //   setLoading(true)
  //   try {
  //       //if (!mountedRef.current) return null;
  //       console.log('loadResultSearchCentral...');

  //       setFilterSearchSelected({
  //         ...filterSearchSelected,
  //         searchClick: {
  //           value: true,
  //           code: true,
  //         },
  //       });

  //   } catch (error) {
  //       catchErrorApi(error)
  //       console.log(error);
  //   } finally {
  //       setLoading(false)
  //       release()
  //   }
  // }, []);

  // Cargar Sucursales...
  const loadData = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        const release = snapshot.retain();
        setLoading(true);
        try {
          if (!mountedRef.current) return null;
          // const sucursalesFetch = await snapshot.getPromise(sucursalesFetchState);
          // console.log("sucursalesFetch => ", sucursalesFetch);
          // setSucursales(sucursalesFetch);

          const atencionFetch = await snapshot.getPromise(atencionFetchState);
          console.log("atencionFetch => ", atencionFetch);
          setAtencion(atencionFetch);

          const clinicasFetch = await snapshot.getPromise(clinicasFetchState);
          console.log("clinicasFetch => ", clinicasFetch);
          setClinicas(clinicasFetch);

          console.log("🔥🔥🔥 TabSearchCentral ==> 🔥🔥🔥", activeTabSearch);

          // let sucursalCod = filterSearchSelected.sucursalSelected.value;
          // console.log("FormSearchCentral => ", sucursalCod);
        } catch (error) {
          catchErrorApi(error);
          console.log(error);
        } finally {
          setLoading(false);
          release();
        }
      },
    []
  );

  useEffect(() => {
    loadData();

    return () => {
      loadData();
    };
  }, [loadData]);

  //   const useStyles = {
  //     label: {
  //       color: theme.palette.primary.main,
  //     },
  //     autocomplete: {
  //       color: theme.palette.primary.main,
  //     },
  //   };

  return (
    <ButtonCustom
      disabled={
        filterSearchSelected.professionalSelected.value === "" &&
        filterSearchSelected.specialitySelected.value === "" &&
        filterSearchSelected.examenSelected.value === "" &&
        filterSearchSelected.procedimientoSelected.value === ""
          ? true
          : false
      }
      loading={loading}
      color="secondary"
      text="BUSCAR"
      icon={<Search />}
    //   style={{ marginRight: 15 }}
      onClick={() => {
        setLoading(true);
        resetProfessionalsMatchCovenant();
        resetProfessionalsNoMatchCovenant();
        resetHoursAvailable();
        eventGA();
        loadResultSearchCentral();
      }}
    />
  );
}
